// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-add-temp-user',
//   templateUrl: './add-temp-user.component.html',
//   styleUrls: ['./add-temp-user.component.css']
// })
// export class AddTempUserComponent {

// }
import { Component, ViewChild, ElementRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { AuthService } from "src/app/services/auth/auth.service";
import { ErrorHandlerService } from "src/app/services/errorHandler/error-handler.service";
import { Group } from "src/app/models/group.model";
import { GroupService } from "src/app/services/group/group.service";
import { ToastService } from "src/app/services/toast/toast.service";
import { TempGroup } from "src/app/models/tempgroup.model";
import { Roles } from "src/app/auth/roles";

interface BulkUser {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  isValid: boolean;
  errors: string[];
}

@Component({
  standalone: false,
  selector: 'app-add-temp-user',
  templateUrl: './add-temp-user.component.html',
  styleUrls: ['./add-temp-user.component.css']
})
export class AddTempUserComponent {
	readonly Roles = Roles;
  @ViewChild("fileInput") fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    private route: ActivatedRoute,
    private groupService: GroupService,
    private router: Router,
    public toastService: ToastService,
    private authService: AuthService,
    private errorService: ErrorHandlerService,
  ) { }

  selectedCompany = {
    companyId: 0,
    companyName: "",
    isDeleted: false,
  };

  selectedPlant = {
    plantId: 0,
    plantName: "",
    isDeleted: false,
  };

  selectedRole = "Non-Admin User";
  groups: TempGroup[] = [];
  firstName = "";
  lastName = "";
  email = "";
  contact = "";

  selectedGroup: TempGroup = {
    tempUserGroupId: 0,
    groupName: "",
    plantId: 0,
    isDeleted: false,
  };

  specialStyle = {
    flex: 0.5,
    marginRight: "32px",
  };

  defaultStyle = {
    flex: 1,
  };

  currentRole: any = "";

  firstNameError: string = "First Name should be 2-35 characters in length";
  lastNameError: string = "Last Name should be 2-35 characters in length";
  emailError: string = "Please enter a valid email address";
  contactError: string = "Please enter a valid contact number";
  errorMessage: { success: boolean, message: string } = {
    success: true,
    message: "",
  };

  showFirstNameError: boolean = false;
  showLastNameError: boolean = false;
  showEmailError: boolean = false;

  // Bulk upload properties
  uploadedFileName: string = "";
  uploadProgress: number = 0;
  uploadStatus: "idle" | "uploading" | "complete" | "error" = "idle";
  showUploadStatus: boolean = false;
  bulkUsers: BulkUser[] = [];
  csvValidated: boolean = false;
  validationMessage: string = "";
  showBulkUploadResults: boolean = false;
  bulkUploadResults: any = null;
  showContactError: boolean = false;

  handleSelectGroup(item: any) {
    this.selectedGroup = item;
  }

  formatContact(event: any) {
    let value = event.target.value.replace(/\D/g, '')
    let formatted = ''

    if (value.length === 0) {
      this.contact = ''
      return
    }

    if (value[0] !== '1') {
      value = '1' + value
    }

    formatted = '1'
    if (value.length > 1) {
      formatted += ' (' + value.substring(1, 4)
    }
    if (value.length >= 4) {
      formatted += ')'
    }
    if (value.length > 4) {
      formatted += '-' + value.substring(4, 7)
    }
    if (value.length > 7) {
      formatted += '-' + value.substring(7, 11)
    }

    this.contact = formatted
  }


  activateSubmitBtn() {
    if (
      this.firstName.length < 2 ||
      this.lastName.length < 2 ||
      this.email.length < 2
    ) {
      return false;
    } else if (this.selectedGroup.tempUserGroupId === 0) {
      return false;
    }
    return true;
  }

  prevState: any = {};
  hasSpecialCharactersOrSpaces(str: string) {
    const regex = /^[a-zA-Z0-9'\-\s]*$/;
    return !regex.test(str);
  }

  isValidEmail(email: string) {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  }

  isFieldValid() {
    let valid = true;
    if (this.firstName.length > 35 || this.firstName.length < 2) {
      this.showFirstNameError = true;
      this.firstNameError = "First Name should be 2-35 characters in length";
      valid = false;
    } else if (this.hasSpecialCharactersOrSpaces(this.firstName)) {
      this.showFirstNameError = true;
      this.firstNameError =
        "Only single quote ( ' ) and hyphen ( - ) are allowed as special characters";
      valid = false;
    } else {
      this.showFirstNameError = false;
    }

    if (this.lastName.length > 35 || this.lastName.length < 2) {
      this.showLastNameError = true;
      this.lastNameError = "Last Name should be 2-35 characters in length";
      valid = false;
    } else if (this.hasSpecialCharactersOrSpaces(this.lastName)) {
      this.showLastNameError = true;
      this.lastNameError =
        "Only single quote ( ' ) and hyphen ( - ) are allowed as special characters";
      valid = false;
    } else {
      this.showLastNameError = false;
    }

    if (!this.isValidEmail(this.email)) {
      this.showEmailError = true;
      this.emailError = "Please enter a valid email address";
      valid = false;
    } else {
      this.showEmailError = false;
    }

    if (this.contact.length < 16) {
      this.contactError = "Contact number must be 10 digits long.";
      this.showContactError = true;
      valid = false;
    } else {
      this.showContactError = false;
    }
    return valid;
  }
  addTempUser() {
    const validateFields = this.isFieldValid();
    if (!validateFields) return;
    const payload = {
      Email: this.email,
      LastName: this.lastName,
      FirstName: this.firstName,
      TempUserGroupId: this.selectedGroup.tempUserGroupId,
      plantId: this.selectedPlant.plantId,
      PhoneNumber: this.contact,
    };

    this.authService.registerTempUser(payload).subscribe({
      next: (request) => {
        this.router.navigate(["settings/user"], {
          state: {
            details: this.prevState,
            prevPage: "Add-Temp-User",
            success: true,
          },
        });
        this.toastService.toastText = `New Temp User Successfully Added to ${this.selectedGroup.groupName} `

        this.toastService.showToast = true
        setTimeout(() => {
          this.toastService.showToast = false

        }, 5000)
      },
      error: (err) => {
        if (
          (err.message =
            "Cannot create user with this email as it is already in use")
        ) {
          this.showEmailError = true;
          this.emailError = err.message;
        }
      },
    });
  }

  pageDetails: string = "Add-Non-Admin-User";

  // Bulk upload methods
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    this.uploadedFileName = file.name;
    this.showUploadStatus = true;
    this.uploadStatus = "uploading";
    this.uploadProgress = 0;
    this.csvValidated = false;
    this.validationMessage = "";
    this.bulkUsers = [];

    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target?.result as string;
      this.simulateUploadProgress(() => {
        this.parseCsvContent(content);
      });
    };
    reader.onerror = () => {
      this.uploadStatus = "error";
      this.validationMessage = "Error reading file. Please try again.";
    };
    reader.readAsText(file);

    // Reset the file input so the same file can be selected again
    input.value = "";
  }

  simulateUploadProgress(callback: () => void): void {
    const interval = setInterval(() => {
      if (this.uploadProgress < 90) {
        this.uploadProgress += 10;
      } else {
        clearInterval(interval);
        this.uploadProgress = 100;
        this.uploadStatus = "complete";
        callback();
      }
    }, 100);
  }

  parseCsvContent(content: string): void {
    const lines = content.split("\n").filter((line) => line.trim() !== "");

    if (lines.length < 2) {
      this.csvValidated = false;
      this.validationMessage =
        "CSV file is empty or has no data rows. Please check the file and try again.";
      return;
    }

    const headers = lines[0].split(",").map((h) => h.trim().toLowerCase());
    const expectedHeaders = [
      "first name",
      "last name",
      "email address",
      "contact number",
    ];

    // Validate headers (at least first 3 are required)
    const hasRequiredHeaders =
      headers.includes("first name") &&
      headers.includes("last name") &&
      headers.includes("email address");

    if (!hasRequiredHeaders) {
      this.csvValidated = false;
      this.validationMessage =
        "Invalid CSV format. Required headers: First Name, Last Name, Email Address. Please download the sample CSV file.";
      return;
    }

    const firstNameIdx = headers.indexOf("first name");
    const lastNameIdx = headers.indexOf("last name");
    const emailIdx = headers.indexOf("email address");
    const phoneIdx = headers.indexOf("contact number");

    const users: BulkUser[] = [];
    let hasErrors = false;

    for (let i = 1; i < lines.length; i++) {
      const values = this.parseCsvLine(lines[i]);
      if (values.length < 3) continue;

      const user: BulkUser = {
        firstName: values[firstNameIdx]?.trim() || "",
        lastName: values[lastNameIdx]?.trim() || "",
        email: values[emailIdx]?.trim() || "",
        phoneNumber: phoneIdx >= 0 ? values[phoneIdx]?.trim() : undefined,
        isValid: true,
        errors: [],
      };

      // Validate user
      this.validateBulkUser(user);
      if (!user.isValid) hasErrors = true;
      users.push(user);
    }

    this.bulkUsers = users;

    if (users.length === 0) {
      this.csvValidated = false;
      this.validationMessage = "No valid data rows found in the CSV file.";
    } else if (hasErrors) {
      this.csvValidated = false;
      const invalidUsers = users.filter((u) => !u.isValid);
      const errorDetails = invalidUsers
        .map(
          (u) => `Row "${u.firstName} ${u.lastName}": ${u.errors.join(", ")}`,
        )
        .join(" | ");
      this.validationMessage = `${invalidUsers.length} of ${users.length} rows have validation errors: ${errorDetails}`;
    } else {
      this.csvValidated = true;
      this.validationMessage = `${users.length} users ready to be uploaded.`;
    }
  }

  parseCsvLine(line: string): string[] {
    const result: string[] = [];
    let current = "";
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      if (char === '"') {
        inQuotes = !inQuotes;
      } else if (char === "," && !inQuotes) {
        result.push(current);
        current = "";
      } else {
        current += char;
      }
    }
    result.push(current);
    return result;
  }

  validateBulkUser(user: BulkUser): void {
    const nameRegex = /^[a-zA-Z0-9'\-\s]*$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    user.errors = [];
    user.isValid = true;

    // Validate first name
    if (
      !user.firstName ||
      user.firstName.length < 2 ||
      user.firstName.length > 35
    ) {
      user.errors.push("First name must be 2-35 characters");
      user.isValid = false;
    } else if (!nameRegex.test(user.firstName)) {
      user.errors.push("First name contains invalid characters");
      user.isValid = false;
    }

    // Validate last name
    if (
      !user.lastName ||
      user.lastName.length < 2 ||
      user.lastName.length > 35
    ) {
      user.errors.push("Last name must be 2-35 characters");
      user.isValid = false;
    } else if (!nameRegex.test(user.lastName)) {
      user.errors.push("Last name contains invalid characters");
      user.isValid = false;
    }

    // Validate email
    if (!user.email || !emailRegex.test(user.email)) {
      user.errors.push("Invalid email address");
      user.isValid = false;
    }

    // Validate phone number (optional but must be 11 digits if provided)
    if (user.phoneNumber && user.phoneNumber.length > 0) {
      const phoneRegex = /^\d{11}$/;
      if (!phoneRegex.test(user.phoneNumber)) {
        user.errors.push("Phone number must be exactly 11 digits");
        user.isValid = false;
      }
    }
  }

  downloadSampleCsv(): void {
    const csvContent =
      "First Name,Last Name,Email Address,Contact Number\nJohn,Doe,john.doe@example.com,12345678901\nJane,Smith,jane.smith@example.com,";
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "bulk_users_template.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  }

  activateBulkSubmitBtn(): boolean {
    return (
      this.selectedGroup.tempUserGroupId !== 0 &&
      this.csvValidated &&
      this.bulkUsers.length > 0
    );
  }

  submitBulkUsers(): void {
    if (!this.activateBulkSubmitBtn()) return;

    const payload = {
      Users: this.bulkUsers.map((u) => ({
        FirstName: u.firstName,
        LastName: u.lastName,
        Email: u.email,
        PhoneNumber: u.phoneNumber || null,
      })),
      Roles: ["Operator"],
      ids: [this.selectedGroup.tempUserGroupId],
    };

    this.authService.registerBulk(payload).subscribe({
      next: (response) => {
        this.bulkUploadResults = response.data;
        this.showBulkUploadResults = true;

        if (response.data.failedCount === 0) {
          this.toastService.showToast = true;
          this.toastService.toastText = `Successfully registered ${response.data.successCount} users`;
          this.toastService.isError = false;

          setTimeout(() => {
            this.toastService.showToast = false;
            this.router.navigate(["settings/user"], {
              state: {
                details: this.prevState,
                prevPage: "Add-Non-Admin-User",
                success: true,
              },
            });
          }, 6000);
        }
      },
      error: (err) => {
        this.validationMessage =
          err.error?.message || "An error occurred during bulk registration.";
        this.csvValidated = false;
      },
    });
  }

  resetBulkUpload(): void {
    this.uploadedFileName = "";
    this.uploadProgress = 0;
    this.uploadStatus = "idle";
    this.showUploadStatus = false;
    this.bulkUsers = [];
    this.csvValidated = false;
    this.validationMessage = "";
    this.showBulkUploadResults = false;
    this.bulkUploadResults = null;
  }

  ngOnInit() {
    this.currentRole = localStorage.getItem("role");
    this.selectedCompany = history.state[0];
    this.selectedPlant = history.state[1];
    this.prevState = {
      company: this.selectedCompany,
      plant: this.selectedPlant,
      group: this.selectedGroup,
      userType: {
        id: 2,
        type: "Temporary Users"
      }
    };

    //Get this for group id
    this.groupService.retrieveActiveTempGroupPlant(this.selectedPlant.plantId).subscribe({
      next: (response) => {
        this.groups = response;
      },
      error: (err) => {
        this.errorMessage = this.errorService.handleRetrievalErrors(err);
      },
    });
  }
}

